import './LightBox.css';
import Download from 'yet-another-react-lightbox/plugins/download';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import { Captions, Thumbnails, Zoom } from 'yet-another-react-lightbox/plugins';
import {
	closeIcon,
	downloadIcon,
	nextIcon,
	previousIcon,
	zoomInIcon,
	zoomOutIcon,
} from './LightBoxIcons';
import { useScroll } from '@anticatrade/shared';
import { useEffect } from 'react';

interface LightBoxProps {
	images: any[];
	isOpen: boolean;
	closeFunc: () => void;
	index: number;
	[key: string]: any;
}

const LightBox = ({ images, isOpen, closeFunc, index, ...rest }: LightBoxProps) => {
	const { disableScroll, enableScroll } = useScroll();

	useEffect(() => {
		if (isOpen) {
			disableScroll();
		} else {
			enableScroll();
		}
	}, [isOpen]);

	return (
		<Lightbox
			open={isOpen}
			index={index}
			close={closeFunc}
			slides={images}
			plugins={[Download, Thumbnails, Zoom, Captions]}
			zoom={{
				scrollToZoom: true,
				maxZoomPixelRatio: 5,
			}}
			render={{
				iconPrev: () => previousIcon,
				iconNext: () => nextIcon,
				iconClose: () => closeIcon,
				iconDownload: () => downloadIcon,
				iconZoomIn: () => zoomInIcon,
				iconZoomOut: () => zoomOutIcon,
			}}
			{...rest}
		/>
	);
};

export { LightBox };
